import React from 'react';

import Spacer from 'components/spacer';

import './index.css';

const InputContainer = ({ children, label, required, renderMiddle }) => {
  return (
    <div className='input-container'>
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      {renderMiddle &&
        <>
          <Spacer size='xs'/>
          {renderMiddle()}
        </>
      }
      {!renderMiddle && <Spacer size='xs'/>}
      {children({ class: 'bp3-input bp3-fill' })}
    </div>
  );
}

export default InputContainer;
